import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { rolesActions as actions, notificationActions } from '../actions';
import { rolesService } from '../services';


/* add Role Sagas */
function* handleAddRoleRequest() {
  const action = yield take(actions.addRoleRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(rolesService.addRole, dataParams);

    if (res.isError) {
      yield put(actions.addRoleError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.addRoleSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.addRoleError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get All Employee Sagas */
function* handleGetAllRolesRequest() {
  const action = yield take(actions.getAllRolesRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(rolesService.getAllRoles, dataParams);

    if (res.isError) {
      yield put(actions.getAllRolesError(res));

    } else {
      yield put(actions.getAllRolesSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllRolesError());
  }
}


/* add Role Sagas */
function* handleGetAllRolesDataRequest() {
  const action = yield take(actions.getAllRolesDataRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(rolesService.getAllRolesData, dataParams);

    if (res.isError) {
      yield put(actions.getAllRolesDataError(res));

    } else {
      yield put(actions.getAllRolesDataSuccess(res));
    }
  } catch (error) {
    yield put(actions.getAllRolesDataError());
  }
}

/* add Role Sagas */
function* handleUpdateRoleRequest() {
  const action = yield take(actions.updateRoleRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(rolesService.updateRole, dataParams);

    if (res.isError) {
      yield put(actions.updateRoleError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.updateRoleSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.updateRoleError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Delete Role Sagas */
function* handleDeleteRoleRequest() {
  const action = yield take(actions.deleteRoleRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(rolesService.deleteRole, dataParams);

    if (res.isError) {
      yield put(actions.deleteRoleError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.deleteRoleSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.deleteRoleError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Assign Role Sagas */
function* handleAssignRoleRequest() {
  const action = yield take(actions.assignRoleRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(rolesService.assignRole, dataParams);

    if (res.isError) {
      yield put(actions.assignRoleError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.assignRoleSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.assignRoleError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}


/* Assign Role Sagas */
function* handleGetEmployeesByRoleRequest() {
  const action = yield take(actions.getEmployeesByRoleRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(rolesService.getEmployeesByRole, dataParams);

    if (res.isError) {
      yield put(actions.getEmployeesByRoleError(res));

    } else {
      yield put(actions.getEmployeesByRoleSuccess(res));
    }

  } catch (error) {
    yield put(actions.getEmployeesByRoleError());
  }
}




/* -----------Watchers------------- */

function* handleAddRoleWatcher() {
  yield takeEvery(
    actions.addRoleRequest,
    handleAddRoleRequest,
  );
}

function* handleGetAllRolesWatcher() {
  yield takeEvery(
    actions.getAllRolesRequest,
    handleGetAllRolesRequest,
  );
}

function* handleGetAllRolesDataWatcher() {
  yield takeEvery(
    actions.getAllRolesDataRequest,
    handleGetAllRolesDataRequest,
  );
}

function* handleUpdateRoleWatcher() {
  yield takeEvery(
    actions.updateRoleRequest,
    handleUpdateRoleRequest,
  );
}

function* handleDeleteRoleWatcher() {
  yield takeEvery(
    actions.deleteRoleRequest,
    handleDeleteRoleRequest,
  );
}

function* handleAssignRoleWatcher() {
  yield takeEvery(
    actions.assignRoleRequest,
    handleAssignRoleRequest,
  );
}

function* handleGetEmployeesByRoleWatcher() {
  yield takeEvery(
    actions.getEmployeesByRoleRequest,
    handleGetEmployeesByRoleRequest,
  );
}



function* rootRolesSaga() {
  yield all([

    handleAddRoleRequest(),
    handleAddRoleWatcher(),

    handleGetAllRolesRequest(),
    handleGetAllRolesWatcher(),

    handleGetAllRolesDataRequest(),
    handleGetAllRolesDataWatcher(),

    handleUpdateRoleRequest(),
    handleUpdateRoleWatcher(),

    handleDeleteRoleRequest(),
    handleDeleteRoleWatcher(),

    handleAssignRoleRequest(),
    handleAssignRoleWatcher(),

    handleGetEmployeesByRoleRequest(),
    handleGetEmployeesByRoleWatcher(),

  ]);
}
export default rootRolesSaga;

